import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventInput]'
})
export class PreventInputDirective {

  @HostListener('keydown', ['$event'])
  onKeyDown(event) {
    let validKeys =['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    if(!validKeys.includes(event['key']))
    {
      event.preventDefault();
    }
  }

}
